import axios from "@/axios";
import coreIAMUrl from "@/apis/coreIAM";

export default {
  fetchAll() {
    return axios.get(`${coreIAMUrl}/organizations`);
  },
  fetchOne(uuid) {
    return axios.get(`${coreIAMUrl}/organizations/${uuid}`);
  },
  createOrganization(name) {
    return axios.post(`${coreIAMUrl}/organizations`, { name: name });
  },
  updateOrganization(organizationUuid, name) {
    return axios.patch(`${coreIAMUrl}/organizations/${organizationUuid}`, {
      name: name,
    });
  },
  deleteOrganization(organizationUuid) {
    return axios.delete(`${coreIAMUrl}/organizations/${organizationUuid}`);
  },
  getOrganizationLocations(organizationUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/locations`
    );
  },
  addOrganizationLocation(organizationUuid, locationUuid) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/locations`,
      {
        uuid: locationUuid,
      }
    );
  },
  removeOrganizationLocation(organizationUuid, locationUuid) {
    return axios.delete(
      `${coreIAMUrl}/organizations/${organizationUuid}/locations/${locationUuid}`
    );
  },
  listOrganizationLocationUsers(organizationUuid, locationUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/locations/${locationUuid}/users`
    );
  },
  addOrganizationLocationUser(organizationUuid, locationUuid, userUuid, role) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/locations/${locationUuid}/add-user`,
      {
        user_uuid: userUuid,
        level: role,
      }
    );
  },
  removeOrganizationLocationUser(
    organizationUuid,
    locationUuid,
    userUuid,
    role
  ) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/locations/${locationUuid}/remove-user`,
      {
        user_uuid: userUuid,
        level: role,
      }
    );
  },
  getOrganizationConcepts(organizationUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/concepts`
    );
  },
  addOrganizationConcept(organizationUuid, conceptUuid) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/concepts`,
      {
        uuid: conceptUuid,
      }
    );
  },
  removeOrganizationConcept(organizationUuid, conceptUuid) {
    return axios.delete(
      `${coreIAMUrl}/organizations/${organizationUuid}/concepts/${conceptUuid}`
    );
  },
  listOrganizationConceptUsers(organizationUuid, conceptUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/concepts/${conceptUuid}/users`
    );
  },
  addOrganizationConceptUser(organizationUuid, conceptUuid, userUuid, role) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/concepts/${conceptUuid}/add-user`,
      {
        user_uuid: userUuid,
        level: role,
      }
    );
  },
  removeOrganizationConceptUser(organizationUuid, conceptUuid, userUuid, role) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/concepts/${conceptUuid}/remove-user`,
      {
        user_uuid: userUuid,
        level: role,
      }
    );
  },
  listOrganizationUsers(organizationUuid) {
    return axios.get(`${coreIAMUrl}/organizations/${organizationUuid}/users`);
  },
  createOrganizationUser(organizationUuid, lastName, firstName, email) {
    return axios.post(`${coreIAMUrl}/organizations/${organizationUuid}/users`, {
      last_name: lastName,
      first_name: firstName,
      email: email,
    });
  },
  removeOrganizationUser(organizationUuid, userUuid) {
    return axios.delete(
      `${coreIAMUrl}/organizations/${organizationUuid}/users/${userUuid}`
    );
  },
  listAdminUsers(organizationUuid) {
    return axios.get(`${coreIAMUrl}/organizations/${organizationUuid}/admins`);
  },
  addAdminToOrganization(organizationUuid, userUuid) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/admins`,
      {
        uuid: userUuid,
      }
    );
  },
  removeAdminFromOrganization(organizationUuid, userUuid) {
    return axios.delete(
      `${coreIAMUrl}/organizations/${organizationUuid}/admins/${userUuid}`
    );
  },
  listEditorUsers(organizationUuid) {
    return axios.get(`${coreIAMUrl}/organizations/${organizationUuid}/editors`);
  },
  addEditorToOrganization(organizationUuid, userUuid) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/editors`,
      {
        uuid: userUuid,
      }
    );
  },
  removeEditorFromOrganization(organizationUuid, userUuid) {
    return axios.delete(
      `${coreIAMUrl}/organizations/${organizationUuid}/editors/${userUuid}`
    );
  },
  listViewerUsers(organizationUuid) {
    return axios.get(`${coreIAMUrl}/organizations/${organizationUuid}/viewers`);
  },
  addViewerToOrganization(organizationUuid, userUuid) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/viewers`,
      {
        uuid: userUuid,
      }
    );
  },
  removeViewerFromOrganization(organizationUuid, userUuid) {
    return axios.delete(
      `${coreIAMUrl}/organizations/${organizationUuid}/viewers/${userUuid}`
    );
  },
  listOrganizationGroups(organizationUuid) {
    return axios.get(`${coreIAMUrl}/organizations/${organizationUuid}/groups`);
  },
  getOrganizationGroup(organizationUuid, groupUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}`
    );
  },
  createOrganizationGroup(organizationUuid, groupName) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups`,
      {
        name: groupName,
      }
    );
  },
  updateOrganizationGroup(organizationUuid, groupUuid, groupName) {
    return axios.patch(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}`,
      {
        name: groupName,
      }
    );
  },
  deleteOrganizationGroup(organizationUuid, groupUuid) {
    return axios.delete(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}`
    );
  },
  listOrganizationGroupUsers(organizationUuid, groupUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}/users`
    );
  },
  addUserToOrganizationGroup(organizationUuid, groupUuid, userUuid) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}/add-user`,
      {
        uuid: userUuid,
      }
    );
  },
  removeUserFromOrganizationGroup(organizationUuid, groupUuid, userUuid) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}/remove-user`,
      {
        uuid: userUuid,
      }
    );
  },
  listAvailableOrganizationGroupRoles(organizationUuid, groupUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}/available-roles`
    );
  },
  listOrganizationGroupRoles(organizationUuid, groupUuid) {
    return axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}/roles`
    );
  },
  addOrganizationGroupRole(organizationUuid, groupUuid, roleUuid, roleName) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}/add-role`,
      {
        uuid: roleUuid,
        name: roleName,
      }
    );
  },
  removeOrganizationGroupRole(organizationUuid, groupUuid, roleUuid, roleName) {
    return axios.post(
      `${coreIAMUrl}/organizations/${organizationUuid}/groups/${groupUuid}/remove-role`,
      {
        uuid: roleUuid,
        name: roleName,
      }
    );
  },
  async getOrganizationUser(organizationUuid, userUuid) {
    return await axios.get(
      `${coreIAMUrl}/organizations/${organizationUuid}/users/${userUuid}`
    );
  },
};
